/*
 * Preorder buy-button label — keeps the submit button reading "Pre-Order".
 *
 * A Preorder is purchasable, so Dawn renders it through the normal enabled
 * Add-to-Cart branch. On every variant change, product-form.js
 * `toggleSubmitButton()` hard-resets the label to `variantStrings.addToCart`.
 * We re-apply the Preorder label right after, using the `variantChange` event
 * that product-info.js publishes immediately AFTER that reset.
 *
 * Single source of truth: snippets/buy-buttons.liquid detects the PRE-ORDER
 * Custom Tag and stamps the translated label onto the button's
 * `data-preorder-label`. This script never re-detects and never hardcodes the
 * string. The label is re-applied only while the button is enabled, so a
 * sold-out / unavailable variant keeps Dawn's "Sold out" / "Unavailable" text.
 *
 * See docs/adr/0005-preorder-button-label-via-pubsub.md.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function applyPreorderLabel(sectionId) {
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!button) return;

    const label = button.dataset.preorderLabel;
    if (!label) return;

    // Only relabel a purchasable button; leave Dawn's sold-out/unavailable text.
    if (button.hasAttribute('disabled')) return;

    const text = button.querySelector('span');
    if (text) text.textContent = label;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    if (sectionId) applyPreorderLabel(sectionId);
  });
})();
